<template>
  <div class="card-wrapper">
    <b-card v-for="manufacturer in manufacturers" :key="manufacturer.id" class="mb-3">
      <div class="d-xs-flex justify-content-between align-items-center">
        <div class="d-lg-flex d-block flex-grow-1">
          <p class="card-text w-40 w-sm-100 mb-lg-0 mb-2 mr-2">
            {{ manufacturer.name_en }}
          </p>
          <p class="card-text w-40 w-sm-100 mb-lg-0 mb-2 mr-2">
            {{ manufacturer.name_ru }}
          </p>
        </div>

        <div class="actions d-flex justify-content-end mt-xs-0 mt-4">
          <i
            @click="showInfoModal(manufacturer.id)"
            class="glyph-icon simple-icon-pencil datalist-icon mr-md-3 mr-2"
          ></i>

          <i @click="handleDelete(manufacturer.id)" class="glyph-icon simple-icon-trash datalist-icon"></i>
        </div>
      </div>
    </b-card>

    <!-- Modals -->
    <b-modal id="editManufacturerModal" ref="editManufacturerModal" size="lg" :title="'Edit Manufacturer'">
      <b-row v-if="!mLoading">
        <b-colxx xxs="12">
          <b-card class="mb-4">
            <b-form @submit.prevent="onSubmit" class="av-tooltip">
              <b-form-group :label="$t('pages.manufacturers.manufacturerNameEn')">
                <b-form-input type="text" v-model="$v.editForm.nameEn.$model" :state="!$v.editForm.nameEn.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.nameEn.required">
                  {{ $t('formErrors.enterName') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="$t('pages.manufacturers.manufacturerNameRu')">
                <b-form-input type="text" v-model="$v.editForm.nameRu.$model" :state="!$v.editForm.nameRu.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.nameRu.required">
                  {{ $t('formErrors.enterName') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="$t('pages.manufacturers.chooseCategory')">
                <v-select
                  v-model="editForm.categoryId"
                  :options="requirements"
                  :reduce="(req) => req.id"
                  label="name"
                />
              </b-form-group>

              <b-button type="submit" variant="primary" class="mt-2">
                {{ $t('buttons.save') }}
              </b-button>
            </b-form>
          </b-card>
        </b-colxx>
      </b-row>
      <div v-else class="d-flex justify-content-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>

      <template slot="modal-footer">
        <b-button variant="secondary" @click="hideModal('editManufacturerModal')">
          {{ $t('buttons.cancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { handleArrayDataInternalization } from '@/utils'
import { apiUrl } from '@/constants/config'

const { required } = require('vuelidate/lib/validators')
export default {
  props: {
    manufacturers: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      apiUrl,
      mLoading: false,
      editForm: {
        nameEn: '',
        nameRu: '',
        categoryId: null
      },
      currentManufacturer: null
    }
  },
  validations: {
    editForm: {
      nameEn: { required },
      nameRu: { required }
    }
  },
  computed: {
    requirements() {
      const requirements = this.$store.getters['manufacturers/requirements']
      return handleArrayDataInternalization(requirements, ['name'], this.$i18n.locale)
    }
  },
  mounted() {
    this.fetchRequirements()
    this.$root.$on('bv::modal::show', (_bvEvent, modalId) => {
      if (modalId === 'editManufacturerModal') {
        this.clearForm()
      }
    })
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 3000, permanent: false })
    },
    fetchRequirements() {
      this.$store.dispatch('manufacturers/fetchRequirements')
    },
    handleDelete(id) {
      this.$confirm({
        message: this.$t('confirm-dialog.question'),
        button: {
          no: this.$t('confirm-dialog.no'),
          yes: this.$t('confirm-dialog.yes')
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch('manufacturers/deleteManufacturer', {
              id,
              vm: this
            })
          }
        }
      })
    },
    showInfoModal(id) {
      this.$bvModal.show('editManufacturerModal')
      this.$store.dispatch('manufacturers/fetchManufacturer', { id, vm: this })
      this.currentManufacturer = id
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const payload = {
          name_en: this.editForm.nameEn,
          name_ru: this.editForm.nameRu
        }
        if (this.editForm.categoryId) {
          payload.category_id = this.editForm.categoryId
        }

        this.$store.dispatch('manufacturers/updateManufacturer', {
          payload,
          id: this.currentManufacturer,
          vm: this
        })
      }
    },
    clearForm() {
      this.editForm.nameEn = ''
      this.editForm.nameRu = ''
      this.editForm.categoryId = null
      this.currentManufacturer = null
    },
    hideModal(refname) {
      this.$refs[refname].hide()
    }
  }
}
</script>
